import {
  loan_request,
  lender_filter_result,
} from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send.ts';
import { arrayToQueryParam } from '@axo/shared/util/string';

export function check({ url: { service: baseURL }, token }: IAPI) {
  return async function check({
    loanRequest,
    lenderIDs,
  }: {
    loanRequest?: Omit<loan_request.CreateLoanRequest, 'LenderID'>;
    lenderIDs?: string[];
  }): Promise<Record<string, lender_filter_result.LenderFilterResult[]>> {
    const lendersInQueryParams = arrayToQueryParam(
      lenderIDs || [],
      'lender_id',
    );
    return send({
      baseURL,
      token,
      path: `/lender-filter/check/loan-request?${lendersInQueryParams}`,
      method: 'POST',
      body: loanRequest,
    });
  };
}
